import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// SAMPLE
interface DomainFilterState {
  selectedDomain: string | null;
}

const initialState: DomainFilterState = {
  selectedDomain: null,
};

const domainFilterSlice = createSlice({
  name: 'domainFilter',
  initialState,
  reducers: {
    setDomainFilter(state, action: PayloadAction<string | null>) {
      state.selectedDomain = action.payload;
    },
    resetDomainFilter(state) {
      state.selectedDomain = null;
    },
  },
});

export const { setDomainFilter, resetDomainFilter } = domainFilterSlice.actions;
export default domainFilterSlice.reducer;
